import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as errorActions from 'actions/errorActions';

/**
 * Note: this class is now also being used to show info/warn messages, not only errors.
 * Should be renamed in the future.
 */
export class Errors extends React.Component {

    constructor(props) {
        super(props);

        this.removeError = this
            .removeError
            .bind(this);

    }

    removeError(errorId) {
        const { errorActions } = this.props;
        errorActions.removeError(errorId);
    }

    render() {

        const { error } = this.props;

        if (!error) {
            return null;
        }

        const currentErrors = error.get('currentErrors');

        if (!currentErrors || currentErrors.count() === 0) {
            return null;
        }

        const getBackgroundColor = error => {
            switch (error.get('type')) {
                case 'info': return this.props.theme.getIn(['palette', 'primary1Color']);
                case 'warn': return '#ffeb3b';
                default: return '#b71c1c';
            }
        };

        const getAutoHideDuration = error => {
            const autoHideDuration = error.get('autoHideDuration');
            if (autoHideDuration === undefined) {
                return 30000; // default existing value
            }
            return autoHideDuration;
        };

        const errorList = [];

        currentErrors.forEach((error, index) => {

            errorList.push(
                <div key={index}>
                    <Snackbar
                        open={true}
                        className="wow-fst-snack-bar"
                        message={error.get('errorMessage')}
                        autoHideDuration={getAutoHideDuration(error)}
                        action="close"
                        onActionTouchTap={() => this.removeError(error.get('id'))}
                        onRequestClose={() => this.removeError(error.get('id'))}
                        bodyStyle={{
                            height: 'auto',
                            lineHeight: '28px',
                            padding: '10px 24px',
                            backgroundColor: getBackgroundColor(error)
                        }}
                    />
                </div>
            );
        });

        return (
            <div>

                {errorList}

            </div>
        );
    }
}
Errors.propTypes = {
    error: PropTypes.object,
    errorActions: PropTypes.object,
    theme: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        error: state.get('error'),
        theme: state.getIn(['site', 'theme', 'baseTheme'])
    };
}

function mapDispatchToProps(dispatch) {
    return {
        errorActions: bindActionCreators(errorActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Errors);



// WEBPACK FOOTER //
// ./src/containers/Errors.js